import { Typography } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';

interface CaregiverBioTitleProps {
  caregiver: Caregiver;
}

const CaregiverBioTitle = ({ caregiver }: CaregiverBioTitleProps) => {
  const caregiverProfile = caregiver.profiles?.commonCaregiverProfile;
  return <Typography variant="h4">{caregiverProfile?.bio.title}</Typography>;
};

export default CaregiverBioTitle;
